import { AbstractDimension, type TemporaryWakamProblem } from '@orus.eu/dimensions'
import { isFailure, type Result } from '@orus.eu/result'

export type WakamAllowedCityCodesResult = Result<string[], TemporaryWakamProblem>

export class MrpwWakamAllowedCityCodesDimension<NAME extends string> extends AbstractDimension<
  NAME,
  WakamAllowedCityCodesResult
> {
  override formatToString(value: WakamAllowedCityCodesResult): string | undefined {
    if (isFailure(value)) {
      return value.problem.type
    }

    return value.output.join(' | ')
  }
}
